import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSpark, getPolySession } from '@poly/sdk-browser/react';
import './Layout.css';

const NAV_ITEMS = [
  { path: '/', icon: '◇', label: 'Dashboard' },
  { path: '/devices', icon: '📱', label: 'Devices' },
  { path: '/platforms', icon: '🔗', label: 'Platforms' },
  { path: '/messages', icon: '💬', label: 'Messages' },
  { path: '/governance', icon: '🔐', label: 'Governance' },
  { path: '/settings', icon: '⚙️', label: 'Settings' },
];

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const session = getPolySession();
  const { signOut } = useSpark();
  
  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };
  
  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">◇</span>
            <span className="logo-text">Poly Messenger</span>
          </div>
          <span className="logo-badge">Console</span>
        </div>
        
        <nav className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `nav-item ${isActive ? 'active' : ''}`
              }
              end={item.path === '/'}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>
        
        <div className="sidebar-footer">
          <div className="connection-status">
            <span className="status-dot healthy"></span>
            <span className="status-text">Connected</span>
          </div>
          
          {session && (
            <div className="user-info">
              <span className="user-name">
                {session.displayName || 'User'}
              </span>
              <button className="btn-logout" onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </aside>
      
      {/* Main Content */}
      <main className="main-content">
        <header className="content-header">
          <h1 className="page-title">
            {NAV_ITEMS.find(item => 
              item.path === location.pathname || 
              (item.path === '/' && location.pathname === '/')
            )?.label || 'Dashboard'}
          </h1>
          
          <div className="header-actions">
            <span className="live-indicator">● LIVE</span>
          </div>
        </header>
        
        <div className="content-body">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
